var r = 14;
function a(t, e) {
  if (!t || (t.type === Date && !t.width && (t.width = r), !t.width))
    return "";
  var i = e + 1;
  return '<col min="'.concat(i, '" max="').concat(i, '" width="').concat(t.width, '" customWidth="1"/>');
}
export {
  a as default
};
//# sourceMappingURL=index.es298.js.map
